import { render, staticRenderFns } from "./AddNewChurch.vue?vue&type=template&id=c80481ec&scoped=true&"
import script from "./AddNewChurch.vue?vue&type=script&lang=js&"
export * from "./AddNewChurch.vue?vue&type=script&lang=js&"
import style0 from "./AddNewChurch.vue?vue&type=style&index=0&id=c80481ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80481ec",
  null
  
)

export default component.exports